import React from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import { DATETIME_FORMAT_FOR_DISPLAY } from "../../../constants/constants";
import moment from "moment";

const ReminderInfoStudio = props => {
  const myType = useSelector(state => state.main.myType ? state.main.myType : null);
  const reminded_at = useSelector(state =>
    state.deadlinesDetail.subjective
      ? state.deadlinesDetail.subjective.reminded_at
      : null);

  return (
    reminded_at &&
    myType === "STUDIO" && (
      <div>
        <FontAwesomeIcon
          style={{
            color: "#0090d1",
            fontSize: "14px",
            marginRight: "4px"
          }}
          icon={["fal", "bells"]}
        />
        <FormattedMessage id="deadlines.pages.detail.reminderSent" />
        {moment(reminded_at).format(DATETIME_FORMAT_FOR_DISPLAY)}
      </div>
    )
  );
};
export default ReminderInfoStudio;
